"use client";

import { FormHelperText, Box, InputAdornment } from "@mui/material";
import { DatePicker as MUIDatePicker, DatePickerProps as MUIDatePickerProps } from "@mui/x-date-pickers";
import Image from "next/image";
import { useState } from "react";

//@ts-ignore
interface DatePickerProps<T> extends MUIDatePickerProps<T> {
  error?: boolean;
  helperText?: string;
  datePickerProps?: any;
  fullWidth?: boolean;
}

function DatePicker<T>({ error, helperText, fullWidth, ...props }: DatePickerProps<T>) {
  const [datePickerOpen, setDatePickerOpen] = useState<boolean>(false);

  const errorStyles = !error
    ? undefined
    : {
        fieldset: {
          border: "1px solid red !important",
        },
        input: {
          "&::placeholder": {
            color: "red",
            opacity: 0.6,
          },
        },
      };

  const styles = {
    "& .MuiInputBase-root": {
      flexDirection: "row-reverse",
    },
    "& .MuiFormLabel-root": {
      paddingLeft: "36px",
      opacity: 0.74,
    },
    "& .MuiInputLabel-shrink": {
      paddingLeft: "unset",
      top: "0px !important",
    },
    "& .MuiInputBase-input": {
      padding: "12px 4px",
    },
  };

  return (
    <div
      style={{ width: fullWidth ? "100%" : "auto" }}
      onClick={datePickerOpen ? undefined : () => setDatePickerOpen(true)}
    >
      {/*//@ts-ignore*/}
      <MUIDatePicker
        //@ts-ignore
        suppressHydrationWarning
        open={datePickerOpen}
        //@ts-ignore
        onAccept={() => setDatePickerOpen(false)}
        onClose={() => setDatePickerOpen(false)}
        {...props}
        sx={{
          ...styles,
          ...errorStyles,
          width: "100%",
        }}
        slotProps={{
          popper: {
            dir: "ltr",
          },
          textField: {
            InputProps: {
              endAdornment: (
                <InputAdornment
                  position="start"
                  suppressHydrationWarning
                >
                  <Box sx={{ margin: "3px 0 0 14px", color: "#3d3d3d" }}>
                    <Image
                      src="/image/icon_date_picker.svg"
                      width={24}
                      height={24}
                      alt="Date Picker Icon"
                    />
                  </Box>
                </InputAdornment>
              ),
            },
          },
        }}
      />
      {error && (
        <FormHelperText
          error={true}
          sx={{ paddingLeft: "12px" }}
        >
          {helperText}
        </FormHelperText>
      )}
    </div>
  );
}

export default DatePicker;
